import { render, staticRenderFns } from "./DepartmentEditFormSubmit.vue?vue&type=template&id=1f360716&"
import script from "./DepartmentEditFormSubmit.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEditFormSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports